angular.module('TetherApp').factory('shortcodeDataService', ['$window', function ($window) {
    let getCurrentShortcodes = function () {
        if ($window.current_shortcodes !== undefined) {
            return $window.current_shortcodes;
        } else {
            return undefined;
        }
    };

    let getShortcodesData = function () {
        if ($window.shortcodesData !== undefined) {
            return $window.shortcodesData;
        } else {
            return [];
        }
    };

    return {
        getCurrentShortcodes: getCurrentShortcodes,
        getShortcodesData: getShortcodesData
    };
}]);
